import { render, staticRenderFns } from "./AssignSupervisor.vue?vue&type=template&id=7b5db33a&scoped=true&"
import script from "./AssignSupervisor.vue?vue&type=script&lang=js&"
export * from "./AssignSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./AssignSupervisor.vue?vue&type=style&index=0&id=7b5db33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5db33a",
  null
  
)

export default component.exports